<template>
  <div class="yjui-dialog modal" v-if="visible" >
    <div class="modal-mask" v-show="isMask"></div>
    <div class="yjui-dialog-box flexView_column"  :style="widthandheight"   v-drag>
    <div class="modal-header flexView_center">
      <h4 class="flex">{{ title }}</h4>
      <div class="operate">
        <span class="close icon-shiti_guanbitouping" @click="onClose"></span>
      </div>
    </div>
    <div class="modal-main flex">
      <div class="tips">{{tips}}</div>
      <slot name="form"></slot>
    </div>
    <div class="modal-footer">
       <Button type="primary" @click="onConfirm" :loading="loading" >{{confirmtext}}</Button>
       <Button  @click="onCancel" v-if="isShowCancel">{{canceltext}}</Button>
    </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Dialog',
  props: {
    width: {
      type: String,
      default: "500"
    },
    height: {
      type: String,
      default: "520"
    },
    title: {
      type: String,
      default: ""
    },
    canceltext: {
      type: String,
      default: "取消"
    },
    
    confirmtext: {
      type: String,
      default: "确定"
    },
    tips: {
      type: String,
      default: ""
    },
    visible: {
      type: Boolean,
      default: true
    },
    isMask: {
      type: Boolean,
      default: false
    },
    isShowCancel: {
      type: Boolean,
      default: true
    },
    loading:{
       type: Boolean,
      default: false
    }
    
  },
  data() {
    return {
      thisfileUrl: this.fileUrl,
      widthandheight:{
                width: this.width+'px',
                height:this.height+'px'
            }
    };
  },
  directives: {
    drag: {
      // 指令的定义
      inserted: function(el, binding, vnode) {
        vnode = vnode.elm;
        var startX = 0,startY = 0,raf;
        el.onmousedown = e => {
        
          if (e.target.className !== "flex") {
            return;
          }
          else
          {
  var e = e || window.event;
          e.preventDefault(); 
          }
          startX = e.pageX - (vnode.lefts || -vnode.offsetWidth / 2);
          startY =e.pageY - (vnode.tops || -vnode.offsetHeight / 2);
          const screenWidth = document.body.clientWidth; // body当前宽度
          const screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
          const dragDomWidth = vnode.offsetWidth; // 对话框宽度
          const dragDomheight = vnode.offsetHeight; // 对话框高度
          const minDragDomLeft = vnode.offsetLeft;
          const maxDragDomLeft = screenWidth - vnode.offsetLeft - dragDomWidth;
          const minDragDomTop = vnode.offsetTop;
          const maxDragDomTop = screenHeight - vnode.offsetTop - dragDomheight;

          document.onmousemove = e => {
            var e = event || evt;
            //阻止页面的滑动默认事件
            e.preventDefault();
            //1先触摸移动
            vnode.lefts = e.pageX - startX;
            vnode.tops = e.pageY - startY;
            //vnode.tops=0;

            // 边界处理
            if (-vnode.lefts > minDragDomLeft) {
              vnode.lefts = -minDragDomLeft;
            } else if (vnode.lefts > maxDragDomLeft) {
              vnode.lefts = maxDragDomLeft;
            }

            if (-vnode.tops > minDragDomTop) {
              vnode.tops = -minDragDomTop;
            } else if (vnode.tops > maxDragDomTop) {
              vnode.tops = maxDragDomTop;
            }
            raf = requestAnimationFrame(function() {
              vnode.style.webkitTransform = vnode.style.transform ="translate3D(" + vnode.lefts + "px," + vnode.tops + "px,0)";
            });
          };
          document.onmouseup = e => {
            var e = event || evt;
            e.preventDefault(); //阻止其他事件
            document.onmousemove = document.onmouseup = null;
          };
        };
        window.onresize = () => {
          //浏览器窗口变化重构位置
          el.style.left = "50%";
          el.style.top = "50%";
          el.style.transform = "translate(-50%, -50%)";
          vnode.lefts = vnode.tops = null;
        };
      }
    }
  },
   methods: {
     onClose(){
        //this.isShow=false;//不能直接改变props中参数的值
        this.$emit("update:visible", false)//直接修改字段不是函数方法
        //this.$emit('on-close'); //通知父组件改变。
     },
      onConfirm (event) {
        console.log("点击了")
            this.$emit('on-Confirm', event);//触发父类的绑定在组件的确定方法
      },
       onCancel (event) {
          this.$emit("update:visible", false)//直接修改字段不是函数方法
            this.$emit('on-change', event);//触发父类的绑定在组件的取消
      }
  }
};
</script>
<style scoped>
.yjui-dialog-box {
  color: #444;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);
  border: 10px solid rgba(0, 0, 0, 0);
  background-color: #fff;
  z-index: 1001;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

 
}
.modal-header {
  overflow: hidden;
  color: #666;
   height: 32px;
  font-size: 14px;
  border-bottom: 1px dotted #e5e5e5;
}
.modal-header h4 {
  cursor: move;
  height: 32px;
  line-height: 30px;
}
.modal-header .operate{font-size: 1.8rem;}
.modal-header .operate .close{cursor: pointer;}
.modal-main {
   padding: 10px 0;
}
.modal-main .tips {
  background-color: #eff7f8;
  padding: 10px 10px;
  margin-bottom: 10px;
  font-size: 1.2rem;
}
.modal-footer {
  text-align: right;
}
.modal-footer .yjui-btn{vertical-align: text-top}
.modal-mask {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background-color: #000;
  opacity: 0.5;
  z-index: 1000;
}
</style>



// WEBPACK FOOTER //
// src/components/Dialog/modalDialog.vue